var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningModalBackgroundImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 123,
    height: 157,
    viewBox: "0 0 123 157",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EFEEEE",
    fillRule: "evenodd",
    d: "M28.498 138C22.152 138 17 132.845 17 126.5S22.152 115 28.498 115C34.848 115 40 120.155 40 126.5c-.397 6.345-5.553 11.5-11.502 11.5zM19 57.104C19 51.958 22.914 48 27.998 48 33.086 48 37 51.958 37 57.104V95.5c0 5.146-3.914 9.5-9.002 9.5-5.084 0-8.998-4.354-8.998-9.5V57.104zm100.871 74.835L48.08 10.962C43.787 3.915 36.768 0 28.57 0 20.377 0 13.357 3.915 9.062 10.962L-62.731 131.94c-4.291 7.047-4.291 15.66-.39 22.707C-59.219 162.085-51.806 166-43.218 166h143.58c8.194 0 15.608-4.307 19.9-11.354 3.901-7.047 3.511-15.66-.39-22.707z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningModalBackgroundImage);
export default __webpack_public_path__ + "static/media/warning-modal-background-image.17aeb6ece532f134fe4876e393582b7a.svg";
export { ForwardRef as ReactComponent };